module.exports = __webpack_public_path__ + "static/media/icon-car-highlight.c1444b56.svg";